module.exports = __webpack_public_path__ + "img/Shivam.1f156dd1.jpg";